import Tasks from 'APP/Tasks';
import { GroupType } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

export const createP2PGroup = async (
  userId: string,
  shouldBeSetAsActive = true
): Promise<Group | null> => {
  const opponent = Entities.usersStore.getUserById(userId);

  if (opponent && opponent.group) {
    shouldBeSetAsActive && Tasks.group.setActiveGroup({ groupId: opponent.group.id });
    return opponent.group;
  }

  return await Tasks.group.createGroupAndInvite(
    {
      members: [Entities.usersStore.Me.id, userId],
      type: GroupType.P2P,
    },
    shouldBeSetAsActive
  );
};
